/**
 * Created by wczeng on 2021/6/3.
 */

export const LOGIN_STATE = 'false'

export const LOGIN = 'login'

export const LOGOUT = 'logout'

export const TITLE = 'title'

export const USERTYPE = ''

export const LOGIN_NAME = ''



// WEBPACK FOOTER //
// ./src/store/types.js